/**
 * @generated SignedSource<<a8f4d6d98cdbc4bf05336b0920ed2b4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useSyncAppleDeveloperAgreementsMutation$variables = {
  brandId: string;
};
export type useSyncAppleDeveloperAgreementsMutation$data = {
  readonly syncAppleDeveloperAgreements: {
    readonly appleDeveloperAgreementsPendingSince: any | null;
    readonly id: string;
    readonly showIosTosAlert: boolean;
  };
};
export type useSyncAppleDeveloperAgreementsMutation = {
  response: useSyncAppleDeveloperAgreementsMutation$data;
  variables: useSyncAppleDeveloperAgreementsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      }
    ],
    "concreteType": "BrandType",
    "kind": "LinkedField",
    "name": "syncAppleDeveloperAgreements",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appleDeveloperAgreementsPendingSince",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showIosTosAlert",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSyncAppleDeveloperAgreementsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSyncAppleDeveloperAgreementsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f553d6a95115f5c73c70f9f72269d481",
    "id": null,
    "metadata": {},
    "name": "useSyncAppleDeveloperAgreementsMutation",
    "operationKind": "mutation",
    "text": "mutation useSyncAppleDeveloperAgreementsMutation(\n  $brandId: ID!\n) {\n  syncAppleDeveloperAgreements(brandId: $brandId) {\n    id\n    appleDeveloperAgreementsPendingSince\n    showIosTosAlert\n  }\n}\n"
  }
};
})();

(node as any).hash = "b46a77674579de1d2a1ca86764ae28ae";

export default node;
